import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.create-samples';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleCreateSamplesEffects {

    CreateSamples$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CREATE_SAMPLES),
        mergeMap((x: ac.PostCreateSamplesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postCreateSamples().pipe(
                map((result: any) => {
                    return new ac.PostCreateSamplesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostCreateSamplesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleSqlService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleSqlService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleSqlService);
        }
        return this.service;
    }
}
